<template>
  <v-dialog v-model="dialog" max-width="350px">
    <v-card
      class="py-2 strategio-card-container"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;position:relative;"
      >
        Acceso a reporte
        <v-btn
          v-if="dialog"
          flat icon small
          color="error"
          style="position:absolute;right:10px;top:3px;color:white;"
          @click="dialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        ¿Desea <b>descargar el archivo</b> desde el navegador o
        <b>desea enviarlo al distribuidor por correo</b>?
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <v-btn
          :loading="isLoadingSendFile"
          small depressed rounded
          class="strategio-dialog-button"
          color="amber darken-2"
          style="color:white;"
          @click.native="sendFile"
        >Enviar por correo</v-btn>
        <v-btn
          :disabled="isLoadingSendFile"
          small depressed rounded
          class="strategio-dialog-button"
          color="green"
          style="color:white;"
          @click.native="downloadFile"
        >Descargar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '@/utils/eventBus'

import supervisorStorage from '@/storage/supervisorStorage'

export default {
  name: 'inconsistencies-report-question-dialog',
  created () {
    eventBus.$off('open-inconsistencies-report-question-dialog')
    eventBus.$on('open-inconsistencies-report-question-dialog', (data) => {
      this.dialog = true
      this.distributorCode2 = data.distributorCode2 || ''
      this.downloadReportLink = data.downloadLink || ''

      this.isLoadingSendFile = false
    })
  },
  data () {
    return {
      dialog: false,
      distributorCode2: '',
      downloadReportLink: '',

      isLoadingSendFile: false
    }
  },
  methods: {
    _download (url) {
      window.open(url, '_blank')
    },
    afterAction () {
      this.isLoadingSendFile = false
      this.dialog = false
    },
    downloadFile () {
      this.isLoadingSendFile = true
      this._download(this.downloadReportLink)
      this.afterAction()
    },
    sendFile () {
      this.isLoadingSendFile = true
      supervisorStorage.sendInconsistenciesMail({
        data: {
          distributorCode2: this.distributorCode2
        },
        onSuccess: () => {
          eventBus.$emit('open-custom-snack-bar', {message: 'Se ha enviado el reporte correctamente', itsOk: true})
          this.afterAction()
        },
        onError: () => {
          eventBus.$emit('open-custom-snack-bar', {message: 'Hubo un error al enviar el reporte', itsOk: false})
          this.afterAction()
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/inconsistencies-report-question-dialog.vue